import "../reportDashboard.scss";

// Solid status pill in the same visual language as the rest of the app —
// feature/open-Items' "Action Status" badge and App.scss's .closeStatus /
// .inprogressStatus / .openStatus: solid fill, bold uppercase white label,
// rounded pill. Tones resolve to $nobg / $malachite / $inprogress etc. in
// reportDashboard.scss, so no colour is carried here.
const STATUS_TONES = {
  open: { tone: "danger", label: "OPEN" },
  closed: { tone: "kudos", label: "CLOSED" },
  "in progress": { tone: "warning", label: "IN PROGRESS" },
  active: { tone: "action", label: "ACTIVE" },
  inactive: { tone: "muted", label: "INACTIVE" },
  expired: { tone: "danger", label: "EXPIRED" },
  critical: { tone: "danger", label: "CRITICAL" },
  high: { tone: "corrective", label: "HIGH" },
  low: { tone: "kudos", label: "LOW" },
  "no date": { tone: "muted", label: "NO DATE" },
  // Training-record states (Lessons/Courses, Safety Meeting instructor
  // completion) — a distinct vocabulary from case Open/Closed, kept visually
  // apart with its own tones even where a word overlaps (e.g. "completed").
  completed: { tone: "kudos", label: "COMPLETED" },
  "not completed": { tone: "warning", label: "NOT COMPLETED" },
  assigned: { tone: "muted", label: "ASSIGNED" },
};

const StatusPill = ({ status }) => {
  const key = (status || "").toLowerCase();
  const config = STATUS_TONES[key] || {
    tone: "muted",
    label: (status || "—").toUpperCase(),
  };

  return <span className={`rdPill is-${config.tone}`}>{config.label}</span>;
};

export default StatusPill;
